export var GET_NAVIGATION = '[NAVIGATION] GET NAVIGATION';
export var SET_NAVIGATION = '[NAVIGATION] SET NAVIGATION';
export var RESET_NAVIGATION = '[NAVIGATION] RESET NAVIGATION';
export function getNavigation() {
    return {
        type: GET_NAVIGATION,
    };
}
export function setNavigation(navigation) {
    return {
        type: SET_NAVIGATION,
        navigation: navigation,
    };
}
export function resetNavigation() {
    return {
        type: RESET_NAVIGATION,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/fuse/navigation.actions.ts
// module id = 554
// module chunks = 81